import { motion } from "framer-motion";
import { MENU, ADDONS } from "../data/menu";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.04 } }),
};

export default function Menu() {
  return (
    <div data-testid="menu-page" className="pt-32 pb-24">
      <header className="max-w-7xl mx-auto px-6 md:px-10 mb-20">
        <p className="text-[10px] uppercase tracking-[0.3em] text-ember mb-6">12&quot; hand-stretched · slow-fermented sourdough</p>
        <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tighter text-charred">
          The <span className="italic text-ember">menu</span>,<br /> in full.
        </h1>
        <p className="mt-8 max-w-xl text-muted2 text-lg leading-relaxed">
          Every pizza is 12 inches, slow-fermented sourdough, blistered at
          900°F in our live wood-fire oven. Strictly vegetarian — many
          vegan, just ask.
        </p>
      </header>

      <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-24">
        {MENU.map((cat) => (
          <section key={cat.id} id={cat.id} data-testid={`menu-category-${cat.id}`}>
            <div className="grid md:grid-cols-12 gap-10">
              <div className="md:col-span-4 md:sticky md:top-28 self-start">
                <p className="text-[10px] uppercase tracking-[0.3em] text-ember mb-4">{cat.subtitle}</p>
                <h2 className="font-serif text-4xl md:text-5xl text-charred leading-[0.95] tracking-tight">{cat.title}</h2>
              </div>

              <div className="md:col-span-8 grid sm:grid-cols-2 gap-x-12 gap-y-2">
                {cat.items.map((it, i) => (
                  <motion.div
                    key={it.name}
                    initial="hidden" whileInView="show" viewport={{ once: true, margin: "-50px" }}
                    variants={fadeUp} custom={i}
                    className="py-6 border-b border-edge"
                    data-testid={`menu-item-${it.name.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    <div className="flex items-baseline justify-between gap-4 mb-2">
                      <h3 className="font-serif text-2xl text-charred leading-tight">{it.name}</h3>
                      <span className="font-serif text-xl text-ember whitespace-nowrap">${it.price.toFixed(2)}</span>
                    </div>
                    <p className="text-sm text-muted2 leading-relaxed">{it.desc}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        ))}

        {/* Add-ons */}
        <section data-testid="menu-addons" className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-ember mb-4">Build it up</p>
            <h2 className="font-serif text-4xl md:text-5xl text-charred leading-[0.95] tracking-tight">Add-ons & Finishers</h2>
            <p className="mt-4 text-muted2 max-w-sm">Stack your sourdough however soulful it needs to be.</p>
          </div>
          <div className="md:col-span-8 grid sm:grid-cols-2 gap-x-12">
            {ADDONS.map((a) => (
              <div key={a.name} className="flex items-baseline justify-between py-4 border-b border-edge">
                <span className="font-serif text-xl text-charred">{a.name}</span>
                <span className="font-serif text-lg text-ember whitespace-nowrap">
                  {a.price === 0 ? <em className="text-sm not-italic text-muted2">{a.note}</em> : `$${a.price.toFixed(2)}`}
                </span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
